import { render, staticRenderFns } from "./ReportDetailScreen.vue?vue&type=template&id=14c40068&scoped=true&"
import script from "./ReportDetailScreen.vue?vue&type=script&lang=js&"
export * from "./ReportDetailScreen.vue?vue&type=script&lang=js&"
import style0 from "./ReportDetailScreen.vue?vue&type=style&index=0&id=14c40068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14c40068",
  null
  
)

export default component.exports